import { Group, Identifiable } from "@planzone/dto";
import { HttpClient, HttpMethods } from "../types/httpClient";

function removePlanzoneResourceGroup(httpClient: HttpClient) {
  return ({ uuid }: Identifiable<Group>) =>
    httpClient.sendHttpRequest<void>({
      endpoint: `/planzoneResourceGroups/${uuid}`,
      method: HttpMethods.DELETE,
    });
}

function removeProjectResourceGroup(httpClient: HttpClient) {
  return ({ uuid }: Identifiable<Group>) =>
    httpClient.sendHttpRequest<void>({
      endpoint: `/projectResourceGroups/${uuid}`,
      method: HttpMethods.DELETE,
    });
}

function removeResourceGroup(httpClient: HttpClient) {
  return (group: Identifiable<Group>) =>
    group.resourceType === "project"
      ? removeProjectResourceGroup(httpClient)(group)
      : removePlanzoneResourceGroup(httpClient)(group);
}

export { removeResourceGroup };
